import React from 'react';
import '../../styles/Header.css';
import { Navbar, Nav, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom'; // Importez Link depuis react-router-dom
import { useCart } from '../../context/CartContext'; // Importez le contexte
import { useState, useEffect } from "react";

export const Navigation = () => {

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Utiliser useEffect pour ajouter ou retirer la classe 'body-darkened'
  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add('body-overflow');
    } else {
      document.body.classList.remove('body-overflow');
    }
  }, [isMenuOpen]);


  //utilise useCart pour obtenir le panier
  const { cart } = useCart();

  // Vérifie que cart est un tableau avant d'utiliser reduce
  const totalItems = Array.isArray(cart)
    ? cart.reduce((sum, item) => sum + (item.quantity ?? 0), 0)
    : 0;


  return (

    <Navbar className="btn_nav_content" >
      <Nav.Link href="/cave" className='btn_home'>Cave du sonneur</Nav.Link>
      { /* un bouton apparaît quand l'écran est plus petit */}
      <Button className="navbar_toggler" onClick={toggleMenu}>
      {isMenuOpen ? "\u2715" : "\u2630"}

      </Button>
      <Nav className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
        <Nav.Link href="/cave" className='btn_align'>Accueil</Nav.Link>
        <Nav.Link href="/cave/vins" className='btn_align'>Vins</Nav.Link>
        <Nav.Link href="/cave/vignoble" className='btn_align'>Vignoble</Nav.Link>
        <Nav.Link href="/musique" className='btn_align_musique'>Musique</Nav.Link>
        <Button as={Link} to="/cave/panier" className="navigation_shop"
          variant="outline-primary" onClick={toggleMenu}
        >
          <span className="cart-count">{totalItems}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 576 512"
            fill="currentColor"
          >
            <path d="M96 0C107.5 0 117.4 8.19 119.6 19.51L121.1 32H541.8C562.1 32 578.3 52.25 572.6 72.66L518.6 264.7C514.7 278.5 502.1 288 487.8 288H170.7L179.9 336H488C501.3 336 512 346.7 512 360C512 373.3 501.3 384 488 384H159.1C148.5 384 138.6 375.8 136.4 364.5L76.14 48H24C10.75 48 0 37.25 0 24C0 10.75 10.75 0 24 0H96zM128 464C128 437.5 149.5 416 176 416C202.5 416 224 437.5 224 464C224 490.5 202.5 512 176 512C149.5 512 128 490.5 128 464zM512 464C512 490.5 490.5 512 464 512C437.5 512 416 490.5 416 464C416 437.5 437.5 416 464 416C490.5 416 512 437.5 512 464z" />
          </svg>
        </Button>
      </Nav>
    </Navbar>
  
  )
}
